<h6 class="bxt-table-title">
    {{ title }} <span *ngIf="page.totalElements">({{ page.totalElements }})</span>
</h6>
<bx-table-header
    [showCreateNew]="!!job()"
    [createNewEnabled]="true"
    (createNew)="createNewQuoteRequestInJob()"
    [searchable]="true"
    [showSettingsActions]="settingsActions && !estimate() && !job()"
    (searchEvent)="setSearch($event)"
    [search]="search ?? ''"
    (settingsActionEvent)="resolveSettingsAction($event)">
    <app-bx-dropdown-generic settings #dropdown [buttonLabel]="'Settings'" [placement]="'right'" [insideClick]="true">
        <div class="group-start">
            <app-bx-dropdown-options [groups]="settingsActions" [type]="'radio'" (select)="resolveSettingsAction($event)">
            </app-bx-dropdown-options>
        </div>
    </app-bx-dropdown-generic>
</bx-table-header>

<div class="panel">
    <div class="panel-body padding-0">
        <div class="table-wrapper" *ngIf="rows.length">
            <ngx-datatable
                #myTable
                class="material bxt-table expandable"
                rowHeight="auto"
                [headerHeight]="50"
                [footerHeight]="50"
                [columnMode]="'force'"
                [rows]="rows"
                [count]="page.totalElements"
                [loadingIndicator]="isLoading() || isRecipientsLoading()"
                [externalPaging]="true"
                (page)="setPage($event)"
                (sort)="onSort($event)"
                [limit]="page.size"
                [offset]="page.pageNumber"
                [scrollbarV]="true"
                [scrollbarH]="false"
                [virtualization]="false"
                [sorts]="[{ prop: sortField, dir: 'desc' }]"
                (resize)="onResize()">
                <!-- Row Detail Template -->
                <ngx-datatable-row-detail [rowHeight]="-1" #myDetailRow>
                    <ng-template let-row="row" let-expanded="expanded" let-rowIndex="rowIndex" ngx-datatable-row-detail-template>
                        <app-ui-quoterequests-recipients-table
                            [row]="row"
                            [rowIndex]="rowIndex"
                            (isLoading)="onRecipientsLoading($event)"
                            [job]="job()"
                            [estimate]="estimate()">
                        </app-ui-quoterequests-recipients-table>
                    </ng-template>
                </ngx-datatable-row-detail>

                <ngx-datatable-column name="#" prop="requestNumber" [cellClass]="'show-pipe'" [headerClass]="'show-pipe'">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <a class="btn-bx-hyperlink" *ngIf="!row.isDeleted" (click)="viewQuoteRequest(row)">QR {{ row.requestNumber }}</a>
                        <input legacy-css type="hidden" ng-value="row.iD_QuoteRequest" />
                        <span *ngIf="row.isDeleted">QR {{ row.requestNumber }}</span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Title" prop="title">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <a class="btn-bx-hyperlink" *ngIf="!row.isDeleted" (click)="viewQuoteRequest(row)"> {{ row.title }}</a>
                        <span *ngIf="row.isDeleted">{{ row.title }}</span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Source" [sortable]="false" *ngIf="!estimate() && !job()">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{ row.iD_Job ? 'Job' : 'Estimate' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Link" prop="linkDescription" [sortable]="false" *ngIf="!estimate() && !job()">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span *ngIf="row.iD_Job; then jobLink; else estimateLink"> </span>
                        <ng-template #estimateLink>
                            <a class="btn-bx-hyperlink" *ngIf="!row.isDeleted" [routerLink]="['/estimates', 'list', row.iD_Estimate]">{{
                                row.estimateView?.description
                            }}</a>
                        </ng-template>
                        <ng-template #jobLink>
                            <a class="btn-bx-hyperlink" *ngIf="!row.isDeleted" [routerLink]="['/jobs', 'list', row.iD_Job]">
                                {{ row.jobView?.description }}</a
                            >
                        </ng-template>
                        <span *ngIf="row.isDeleted">{{ row.iD_Job ? row.jobView?.description : row.estimateView?.description }}</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Date Released" prop="dateReleased">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span *ngIf="row.dateReleased">{{ row.dateReleased | date }}</span>
                        <span *ngIf="!row.dateReleased">Not released</span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Status" prop="status">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span class="label label-min-100" [ngClass]="'label-' + sharedData.labelStatus[row.status]">{{ row.status }}</span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Deadline" prop="dateDeadline" *ngIf="!showingDeleted">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{ calcExpiryDays(row) }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Date Deleted" prop="dateDeleted" *ngIf="showingDeleted">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{ row.dateDeleted | date }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Responses" *ngIf="!showingDeleted" [cellClass]="'align-center'" [sortable]="false">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span *ngIf="getSubmittedResponses(row)"
                            ><strong>{{ getSubmittedResponses(row) }}</strong></span
                        >
                        <span *ngIf="!getSubmittedResponses(row)">-</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                    [sortable]="false"
                    [canAutoResize]="false"
                    [draggable]="false"
                    [resizeable]="false"
                    [cellClass]="'right-align'"
                    [headerClass]="'disabled'"
                    [width]="250">
                    <ng-template let-row="row" let-expanded="expanded" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                        <div class="quoterequest-btn-row">
                            <button
                                type="button"
                                class="btn-bx-secondary-stroked"
                                *ngIf="!row.isDeleted"
                                [disabled]="!permissionService.isAvailable('request-for-quote.maintain-rfqs.create-edit-send-rfq')"
                                (click)="viewQuoteRequest(row)">
                                Edit
                            </button>
                            <button
                                type="button"
                                class="btn-bx-secondary-stroked"
                                type="button"
                                *ngIf="
                                    !row.isDeleted && !row.dateReleased && row.status !== 'Closed' && row.quoteRequestRecipients.length > 0
                                "
                                [disabled]="!permissionService.isAvailable('request-for-quote.maintain-rfqs.create-edit-send-rfq')"
                                (click)="sendQuoteRequest(row)">
                                Send
                            </button>

                            <button
                                type="button"
                                class="btn btn-sm btn-default"
                                *ngIf="row.isDeleted"
                                [disabled]="!permissionService.isAvailable('request-for-quote.maintain-rfqs.delete-rfq')"
                                (click)="recover(row)"
                                tooltip="Recover"
                                container="body">
                                <i class="ti-reload"></i>
                            </button>
                            <button
                                *ngIf="!row.isDeleted && row.status !== 'Draft' && row.quoteRequestRecipients.length > 0"
                                type="button"
                                class="btn-bx-secondary"
                                [disabled]="!permissionService.isAvailable('request-for-quote.maintain-rfqs.view-rfq-responses')"
                                (click)="toggleExpandRow(row)"
                                [class.expanded]="expanded"
                                [attr.id]="'expand-btn_' + rowIndex">
                                <span ref="toggle-label">{{ expanded ? 'Hide' : 'Show' }} </span>
                                <strong>{{ row.quoteRequestRecipients.length }}</strong> Recipient<span
                                    *ngIf="row.quoteRequestRecipients.length !== 1"
                                    >s</span
                                >
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm btn-danger"
                                *ngIf="!row.isDeleted"
                                [disabled]="!permissionService.isAvailable('request-for-quote.maintain-rfqs.delete-rfq')"
                                (click)="deleteQuoteRequest($event, row)"
                                tooltip="Delete"
                                container="body">
                                <i class="ti-trash"></i>
                            </button>
                        </div>
                        <p *ngIf="!row.isDeleted && !row.quoteRequestRecipients.length" class="has-error">
                            <span class="error"><small>Recipients not selected</small></span>
                        </p>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-footer>
                    <ng-template
                        ngx-datatable-footer-template
                        let-rowCount="rowCount"
                        let-pageSize="pageSize"
                        let-selectedCount="selectedCount"
                        let-curPage="curPage"
                        let-offset="offset"
                        let-isVisible="isVisible">
                        <app-table-footer-paging *ngIf="rowCount > 10" [size]="page.size" (pageLimitChange)="pageLimit($event)">
                        </app-table-footer-paging>

                        <datatable-pager
                            [pagerLeftArrowIcon]="'datatable-icon-left'"
                            [pagerRightArrowIcon]="'datatable-icon-right'"
                            [pagerPreviousIcon]="'datatable-icon-prev'"
                            [pagerNextIcon]="'datatable-icon-skip'"
                            [page]="curPage"
                            [size]="pageSize"
                            [count]="rowCount"
                            [hidden]="!(rowCount / pageSize > 1)"
                            (change)="myTable.onFooterPage($event)">
                        </datatable-pager>
                    </ng-template>
                </ngx-datatable-footer>
            </ngx-datatable>
        </div>
    </div>
</div>
